import societyReactivationReducer from './reducer';

export function getSocietyReactivationModule() {
  return {
    id: 'societyReactivation',
    reducerMap: {
      societyReactivation: societyReactivationReducer,
    },
    sagas: [],
  };
}
